import React, { useState, useContext } from "react";
import InputMask from "react-input-mask";
import useForkRef from "core/hooks/useForkRef";
import {inputFactory} from "core/Utils/Analytics/tagService";
import { store } from "store.js";

const Input = React.forwardRef((props, ref) => {
  let {
    label,
    type = "text",
    className = "",
    error,
    value: valueProp = "",
    formatChars,
    as: inputComponent = "input",
    mask,
    showPassword = "false",
    name: propName = label,
    id: propId = propName,
    onlyNumbers = false,
    onBlur,
    onChange,
    tabIndex,
    inputRef: inputRefProp,
    ...other
  } = props;
  const globalState = useContext(store);
  const { state } = globalState;
  const currentFlow = state.analytics.currentFlow;
  const [inputValue, setInputValue] = useState(valueProp);
  const [displayPassword, setDisplayPassword] = useState(!showPassword);
  const errorClass = error ? " mdn-Input--attentionField" : "";
  const activeClass = inputValue ? "mdn-Input--activatedField" : "";
  const finalExtraClasses = `${activeClass} ${errorClass} ${className}`.trim();

  function handleChange(event, ...args) {
    setInputValue(event.target.value);
    // Perform in the willUpdate
    if (onChange) {
      onChange(event, args);
    }
  }

  function handleBlur(event, ...args) {
    const { value = "" } = event.target;
    if (value !== "") {
      inputFactory(label, currentFlow, event)
   
    }
    if (onBlur) {
      onBlur(event, args);
    }
  }

  function handleShowPassword() {
    setDisplayPassword(!displayPassword);
  }
  const inputRef = React.useRef();

  const handleInputRef = useForkRef(inputRef, inputRefProp);

  let InputComponent = inputComponent;
  let inputProps = {
    type: verifyType(type, showPassword),
    ref: handleInputRef,
  };

  function handleKeyDown(event) {
    if (props.blockPaste) {
      let charCode = String.fromCharCode(event.which).toLowerCase();
      if (event.ctrlKey && charCode === "v") {
        if (props.blockPaste) {
          event.preventDefault();
        } else {
          return true;
        }
      }
      if (event.metaKey && charCode === "v") {
        if (props.blockPaste) {
          event.preventDefault();
        } else {
          return true;
        }
      }
    }
  }

  if (typeof InputComponent !== "string") {
    inputProps = {
      // Rename ref to inputRef as we don't know the
      // provided `inputComponent` structure.
      inputRef: handleInputRef,
      ...inputProps,
      ref: null,
    };
  } else {
    inputProps = {
      ...inputProps,
    };
  }
  let finalProps = {
    ...inputProps,
    ref: inputRef,
    value: valueProp || undefined,
  };

  function verifyType(type, showPassword) {
    if (type === "password" && displayPassword === true) {
      return "text";
    } else {
      return type;
    }
  }

  function onlyNumbersProps(onlyNumbers) {
    if (onlyNumbers) {
      return {
        inputMode: "numeric",
        pattern: "[0-9-.()/]+",
      };
    }
    return null;
  }
  return (
    <div className={`mdn-Input ${finalExtraClasses}`}>
      {mask ? (
        <InputMask
          aria-invalid={error ? true : false}
          aria-describedby={error ? `error-${propId}` : null}
          id={propId}
          name={propName}
          type={type}
          data-mdn-type={type}
          className="mdn-Input-field"
          mask={mask}
          formatChars={formatChars}
          onChange={handleChange}
          onBlur={handleBlur}
          value={inputValue}
          inputRef={inputRef}
          tabIndex={tabIndex}
          ref={props.inputRef}
          {...onlyNumbersProps(onlyNumbers)}
          {...other}
        />
      ) : (
        <InputComponent
          data-mdn-type={type}
          aria-invalid={error ? true : false}
          aria-describedby={error ? `error-${propId}` : null}
          id={propId}
          tabIndex={tabIndex}
          name={propName}
          className="mdn-Input-field"
          value={valueProp}
          {...onlyNumbersProps(onlyNumbers)}
          {...finalProps}
          onChange={handleChange}
          onBlur={handleBlur}
          onKeyDown={handleKeyDown}
          disabled={props.disabled}
        />
      )}

      <label htmlFor={propId} className="mdn-Input-label">
        {label}
      </label>
      {error && (
        <small
          role="alert"
          id={`error-${propId}`}
          className="mdn-Input-errorFeedback"
        >
          {error}
        </small>
      )}
      {type === "password" && (
        <button
          {...finalProps}
          type="button"
          style={{ cursor: "pointer" }}
          onClick={handleShowPassword}
          className="mdn-Input-action"
          data-mdn-action="reveal-password"
          disabled={props.disabled}
          tabIndex={tabIndex}
        >
          <span
            aria-label="Ocultar senha"
            className="mdn-Icon-ocultar mdn-Icon--md"
          >
            <title>Ocultar senha</title>
          </span>
          <span
            aria-label="Exibir senha"
            className="mdn-Icon-exibir mdn-Icon--md"
          >
            <title>Exibir senha</title>
          </span>
        </button>
      )}
    </div>
  );
});
export default Input;

export { Select } from "components/Select";
